import Vue from 'vue'

export default {
  setProduct (state, data) {
    state.data = data
  },

  setTranslatedDescription (state, data) {
    state.translatedDescription = data
  },
  setTranslatedDefectsDescription (state, data) {
    state.translatedDefectsDescription = data
  },

  setProductAuctionAndContext (state, data) {
    state.data.auction = data.auction
    state.data.context = data.context
  },

  setAuction (state, data) {
    Vue.set(state.data, 'auction', data)
  },

  setBiddingAdviserValue (state, data) {
    state.biddingAdviserValue = data
  },

  setAuctionEndingAt (state, endingAt) {
    // console.log('setAuctionEndingAt', endingAt)
    if (state.data.auction) {
      // console.log('from', state.data.auction.endingAt)
      state.data.auction.endingAt = endingAt
    }
  },

  addToWatchList (state) {
    if (state.data.context) {
      state.data.context.watchlist = true
    }
  },

  removeFromWatchList (state) {
    if (state.data.context) {
      state.data.context.watchlist = false
    }
  },

  setWaitingForAnswer (state, waitingForAnswer) {
    if (state.data) {
      state.data.context.waitingForAnswer = waitingForAnswer
    }
  }

}
